<template>
  <div class="slider-wrapper">
    <vue-slider
      v-model="internalValueSlider"
      :min="parseInt(minDate)"
      :max="parseInt(maxDate)"
      :min-range="1"
      :marks="objectMarks"
      :tooltip-formatter="formatterDate"
      :interval="1"
      :height="3"
      :style="{ padding: '0'}"
      :process-style="{ backgroundColor: 'black' }"
      :tooltip-style="{ backgroundColor: 'black', borderColor: 'black', fontSize: '10px' }"
      :dot-style="{ backgroundColor: 'black', borderColor: 'black', boxShadow: '0.5px 0.5px 2px 1px rgb(0 0 0 / 32%)' }"
      @drag-end="setNewRange"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  components: {
    VueSlider,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {},
    minDate: {},
    maxDate: {},
    type: {
      type: String,
    },
  },
  data() {
    return {
      formatterDate: v => `${dayjs(parseInt(v)).format('DD/MM/YYYY')}`,
      currentValue: null,
    }
  },
  computed: {
    objectMarks() {
      if (this.minDate && this.maxDate) {
        let minNumberDate = parseInt(this.minDate)
        let maxNumberDate = parseInt(this.maxDate)
        return {
          [minNumberDate]: {
            label: dayjs(minNumberDate).format('DD/MM/YYYY'),
            labelStyle: {
              position: 'absolute',
              left: '5px',
              fontSize: '10px',
            },
          },
          [maxNumberDate]: {
            label: dayjs(maxNumberDate).format('DD/MM/YYYY'),
            labelStyle: {
              position: 'absolute',
              left: '-5px',
              fontSize: '10px',
            },
          },
        }
      } else return false
    },
    internalValueSlider: {
      get: function () {
        if (this.$route.query && this.$route.query.singUpDate && this.type === 'singUpDate') {
          let singup = this.$route.query.singUpDate.split(',')
          return [parseInt(dayjs(singup[0]).format("x")), parseInt(dayjs(singup[1].split('T')[0] + 'T00:00:00').format("x"))]
        }
        else if (this.$route.query && this.$route.query.visitDate && this.type === 'visitDate') {
          let visit = this.$route.query.visitDate.split(',')
          return [parseInt(dayjs(visit[0]).format("x")), parseInt(dayjs(visit[1].split('T')[0] + 'T00:00:00').format("x"))]
        }
        else if (this.$route.query && this.$route.query.update && this.type === 'update') {
          let update = this.$route.query.update.split(',')
          return [parseInt(dayjs(update[0]).format("x")), parseInt(dayjs(update[1]).format("x"))]
        } else {
          return [
            parseInt(this.minDate), parseInt(this.maxDate)
          ]
        }
      },
      set: function (newValue) {
        this.currentValue = newValue
        //this.rangeChange(newValue[0], newValue[1])
      },
    },
  },
  watch: {
    
  },
  mounted() {
    // this.initSortedOptions()
  },
  methods: {
    setNewRange () {
      let newValue = this.currentValue
      this.rangeChange(newValue[0], newValue[1])
    },
    rangeChange(minVal, maxVal) {
      this.$emit('change', minVal, maxVal)
      // this.internalChecks = this.sortedOptions
      //   .map(v => v.id)
      //   .slice(this.mappedSortedOp.indexOf(minVal), this.mappedSortedOp.indexOf(maxVal) + 1)
    },
  },
}
</script>

<style lang="stylus" scoped>
.custom-dropdown
  position: relative
  flex: 1 1 0%
  border: 1px solid $grey-grey
  border-radius: 8px
  background-color: #fff

  &.open
    border-color: #000

    &:before
      border-color: $bcn-grey

    &:after
      transform: translateY(-50%) rotate(180deg)

  &:before
    position: absolute
    top: -4px
    left: -4px
    z-index: -1
    width: calc(100% + 8px)
    height: calc(100% + 8px)
    border: 4px solid #fff
    border-radius: 8px
    content: ""

  &:after
    m-icon("chevron-down", 24)
    position: absolute
    top: 50%
    right: vw(10px)
    content: ""
    transition: transform 0.15s ease-in-out
    transform: translateY(-50%)
    pointer-events: none

  &.frozen
    opacity: 0.5
    pointer-events: none

    &:before,
    &:after
      display: none

.current
  m-font-size(14, 18)
  padding: vw(6px) vw(40px) vw(6px) vw(12px)
  color: $grey
  cursor: pointer
  min-width: vw(150px)

.slider-wrapper
  padding: 40px 33px 35px
  height: auto

.dropdown
  position: absolute
  top: calc(100% + 3px)
  left: 0
  z-index: 3
  overflow: hidden
  width: 100%
  border: 1px solid $bcn-other-grey
  border-radius: 8px
  background-color: #fff

  .select-helper-container
    display: flex
    justify-content: space-between
    padding: vw(8px) vw(10px) vw(5px)
    width: 100%

    span
      m-font-size(11, 14)
      color: $corporate_color
      cursor: pointer

    .align-right
      text-align: right

  > div
    overflow-y: auto
    max-height: vw(200px)

.option
  m-font-size(14, 18)
  padding-right: vw(6px)
  padding-left: vw(6px)
  word-break: break-word
  overflow-wrap: break-word

  &:first-child
    padding-top: vw(6px)

  &:last-child
    padding-bottom: vw(6px)

.option-wrapper
  display: flex

  .handle
    m-icon("drag", 20)
    margin-top: vw(7px)

.sub-options
  margin-top: vw(5px)

.sub-options-title
  margin-left: vw(5px)

.sub-option
  display: flex
  align-items: center
  padding: vw(5px) 0 vw(5px) vw(36px)

  .label
    flex: 1 1 0%

  > input
    margin-right: vw(5px)

.ghost
  opacity: 0

.fake-checkbox-container,
.fake-radio-container
  flex: 1 1 0%

  > label
    display: flex
    padding: vw(6px) vw(8px)
    width: 100%
    border-radius: 8px
    cursor: pointer

    &.selected
      font-weight: bold

    &:hover
      background-color: $bcn-very-light-grey

    > input
      margin: 0
      width: 0
      height: 0
      opacity: 0

      &:checked
        + .fake-checkbox
          m-icon("check-box", 20)

  .fake-checkbox
    m-icon("check-box-blank", 20)
    margin-top: vw(1px)
    margin-right: vw(10px)

  .label-text
    m-font-size(14, 22)
    flex: 1 1 0%
    cursor: pointer
</style>
